var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14v5H0v-5h5Zm7 0v5H7v-5h5Zm7 0v5h-5v-5h5ZM5 7v5H0V7h5Zm7 0v5H7V7h5Zm7 0v5h-5V7h5ZM5 0v5H0V0h5Zm7 0v5H7V0h5Zm7 0v5h-5V0h5Z",
    stroke: "none !important",
    fill: "param(fill)",
    fillRule: "evenodd"
  })));
};
export default SvgGrid;